export type InputMethodValue = 'voice' | 'keyboard';

export const INPUT_METHOD_STORAGE_KEY = 'nurau_input_method';
export const DEFAULT_INPUT_METHOD: InputMethodValue = 'voice';

export const readStoredInputMethod = (): InputMethodValue => {
  const stored = localStorage.getItem(INPUT_METHOD_STORAGE_KEY);
  return stored === 'voice' || stored === 'keyboard'
    ? stored
    : DEFAULT_INPUT_METHOD;
};

export const writeStoredInputMethod = (value: InputMethodValue): void => {
  localStorage.setItem(INPUT_METHOD_STORAGE_KEY, value);
};
